import cn from 'clsx';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { gritComponentStyles } from '../gritComponents/gritComponentStyles';
//import { logJson } from '../../temp/debugPolicies/DebugOut/log';
import { getDebugPolicyLog, selectSelectedNodeId } from '../../store';
import { useSelector } from 'react-redux';

const DebugPopUp = () => {
  const classes = gritComponentStyles();
  const label = useSelector(selectSelectedNodeId);
  const debuglog = useSelector(getDebugPolicyLog);
  const logJson = debuglog.lastUserLog;

  function getDigits() {
    let endingDigits = -1;
    if (!label.toLowerCase().startsWith('debug')) {
      return -1;
    }
    let matches = label.match(/[0-9]+$/);
    if (matches) {
      endingDigits = parseInt(matches[0]);
    }
    return endingDigits;
  }

  function getDebugClaimsToDisplay() {
    let display = [];
    let d = getDigits();
    if (d == -1) {
      return [];
    }
    //find log
    let log = null;
    for (let i = 0; i < logJson.length; i++) {
      if (
        parseInt(logJson[i].debugStepIndex) === d &&
        logJson[i].debugIsVtp === false &&
        logJson[i].debugIsSubjourney === false
      ) {
        log = logJson[i];
      }
    }
    // if(log){

    // }
    return log;
  }
  let debugClaims: any = getDebugClaimsToDisplay();
  console.log(debugClaims);
  return (
    <div style={{}}>
      <div className={cn(classes.popup, classes.debuggerPopup)}>
        <div className={cn(classes.header)}>
          <div className={cn(classes.flexRow, classes.alignCenter)}>
            <div className={classes.actionName}>Log Info</div>
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '100%' }}>
          {/* <div></div> */}
          <div style={{ padding: '0px 1rem' }}>
            <h4>Current State</h4>
            <br />
            {Object.keys(debugClaims).map((property: any) => {
              return !property.toLowerCase().startsWith('debug') ? (
                <div>{`${property}: ${debugClaims[property]}`}</div>
              ) : null;
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

// export default withAITracking(reactPlugin, DebugPopUp);
export default DebugPopUp;
